export enum VehicleRequestTypeEnum {
  NEW_IMATRICULATION = 'NEW_IMATRICULATION',
  VEHICLE_CHANGE = 'VEHICLE_CHANGE',
  COMPANY_CHANGE = 'COMPANY_CHANGE',
  OTHER = 'OTHER',
}

export const getVehicleRequestTypeLabel = (value: VehicleRequestTypeEnum): string => {
  switch (value) {
    case VehicleRequestTypeEnum.NEW_IMATRICULATION:
      return $localize`Nouvelle immatriculation`;
    case VehicleRequestTypeEnum.VEHICLE_CHANGE:
      return $localize`Changement de véhicule`;
    case VehicleRequestTypeEnum.COMPANY_CHANGE:
      return $localize`Changement de compagnie`;
    case VehicleRequestTypeEnum.OTHER:
      return $localize`Autre`;
    default:
      return '';
  }
};
